import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService as EsAuthService } from '@examsoft/es-login';

interface IUsage{
  institute: string;
  instituteName: string;
  billingStartDate: string;
  billingEndDate: string;
  productType: string;
  units: number;
  unitPrice: number;
  overagePrice: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
  user: string
}


@Injectable({ providedIn: 'root' })
export class UsageService {

  constructor(
    private http: HttpClient,
    private esAuth: EsAuthService
  ) {
  }

  public httpOptions(data = {}): { headers: HttpHeaders } {
    let headers = new HttpHeaders({
      'Authorization': this.esAuth.getJwt(),
      'Content-Type': 'application/json'
    });



    return { headers, ...data };
  }

  public get(app, instituteId, search = {}): Promise<any>{
    let url = `${environment.urls.usage}/${app}/institutions/${instituteId}/summary${this.query(search)}`;
    return this.http.get(url, this.httpOptions()).toPromise();
  }

  public post(app, data: IUsage){
    let url = `${environment.urls.usage}/${app}/institutions`;
    return this.http.post(url, data, this.httpOptions()).toPromise();
  }

  public put(app, data: IUsage){
    let url = `${environment.urls.usage}/${app}/institutions`;
    return this.http.put(url, data, this.httpOptions()).toPromise();
  }

  public delete(app, body){
    let url = `${environment.urls.usage}/${app}/institutions`;
    return this.http.delete(url, this.httpOptions({ body })).toPromise();
  }

  public export(app, instituteId, search = {}){
    let url = `${environment.urls.usage}/${app}/institutions/${instituteId}/export${this.query(search)}`;
    return this.http.get(url, { responseType: 'text' }).toPromise().then( data => {
      return this.http.get(data).toPromise()
    })
  }

  private query(data: any){
    let result = Object.entries(data).map(([key, val]) => `${key}=${val}`).join('&');
    return result.length ? `?${result}` : '';
  }
}
